import { api } from "@/api";
import { virtualStreamPath } from "./virtualSportType";

// One quarter / overtime period score. Q1..Q4 come first, then OT periods.
export interface VirtualBasketballPeriodScore {
  home: number;
  away: number;
}

export interface VirtualBasketballRoundMatch {
  matchId: number;
  home: string;
  away: string;
  homeUid: number; // VBL team uid (= logo teamid); 0 if absent
  awayUid: number;
  startAt: number; // unix s
  score: string | null; // final "H:A" (incl. OT); null until match end
  periods: VirtualBasketballPeriodScore[] | null; // null until match end
  winner: "1" | "2" | null; // null until match end
}

// One VBL matchday's matches (final score + quarter scores) for the results view.
export const getVirtualBasketballRound = async (
  leagueId: number,
  round: number
): Promise<VirtualBasketballRoundMatch[]> => {
  const res = await api.client.get(
    virtualStreamPath("virtual-basketball", "round"),
    { params: { leagueId, round } }
  );
  return res.data?.matches ?? [];
};
